import { useMemo, useState } from "react";
import { Col, Collapse, Row, Spinner, DropdownButton,Dropdown, Form } from "react-bootstrap";
import { SubmitResetButton1} from "../../Client/ClientUtil";
import { axiosPutWithHeader, ShowGenericAlertError } from "../../Common/axios";
import { useMediaQuery } from 'react-responsive';

export function EventAnalyser ({menuArray,userData,clientData,eventData,handleEventKey,handleEventData}) {
  const [spinner, setSpinner] = useState('Loading - Event Anayser');
  const [planetCategory,setPlanetCategory] = useState([0,0,0,0,0,0,0,0,0]);
  const [planetOrder,setPlanetOrder] = useState([0,0,0,0,0,0,0,0,0]);
  const [eventCategoryValues,setEventCategoryValues]=useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [msgtitle, setMsgtitle] = useState('Error');
  const [msgbody, setMsgbody] = useState('');
  const [msgbutton, setMsgbutton] = useState('');
  const loop=['',1,2,3,4,5,6,7,8,9];
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const handleAlertCallback = ()=>{
    setErrorMessage(null);
  }

  const handleEvents = (key)=> {
    handleEventKey(key);
  }
  useMemo(() => {
    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetCategory!==null
      &eventData.userEvent.planetCategory!==undefined
    ) {
      setPlanetCategory(eventData.userEvent.planetCategory.split(","));
    } else {
      setPlanetCategory([0,0,0,0,0,0,0,0,0]);
    }

    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetOrder!==null
      &&eventData.userEvent.planetOrder!==undefined
    ) {
      setPlanetOrder(eventData.userEvent.planetOrder.split(","));
    } else {
      setPlanetOrder([0,0,0,0,0,0,0,0,0]);
    }

    if(eventData!==null && eventData.currentEvent!==null) {
      setEventCategoryValues([
          eventData.currentEvent.primary,eventData.currentEvent.secondary,eventData.currentEvent.supportive,
          eventData.currentEvent.bad,eventData.currentEvent.worse,eventData.currentEvent.worst
       ]);
    }
    setSpinner(null);
  }, [eventData]);

  function handleColorInput(event,planetIndex){
    const tempPlanetCategory = [...planetCategory];
    tempPlanetCategory[planetIndex]=event.target.value;
    setPlanetCategory(tempPlanetCategory);
  }

    function handleOrderInput(event,planetIndex){
    const tempPlanetOrder = [...planetOrder];
    tempPlanetOrder[planetIndex]=event.target.value;
    setPlanetOrder(tempPlanetOrder);
  }

  function getTag(str){
    if(str===null||str==="") return "";
    var arr = str.split(",");
    for(var i=0; i<arr.length;i++) {
      if(arr[i]===null||arr[i]==="") continue;
      if(i===0) {
        arr[i]=<font color={getColor(arr[i])}><b>{arr[i]}</b></font>;
      } else {
        if(isMobile) {
          arr[i]=<>,<font color={getColor(arr[i])}><b>{arr[i]}</b></font></>;
        } else {
          arr[i]=<>, <font color={getColor(arr[i])}><b>{arr[i]}</b></font></>;
        }
      } 
    }
    return arr;
  }

  function getColor(value){
    if(value===null||eventData===null||eventData.currentEvent===null||eventData.allEventCategoryColor===null){
      return "black";
    }
    value = value.trim();

    for(var i=0; eventCategoryValues!==null && i<eventCategoryValues.length; i++){
      if(isExistinArray(eventCategoryValues[i],value)) {
        return eventData.allEventCategoryColor[i];
      }
    }
    return "black";
  }

  function isExistinArray(str,value) {
    if(str===null||str===undefined) return false;
    var array = str.split(",");
    for(var i=0;i<array.length;i++) {
      if(array[i].toString()===value) {
        return true;
      }
    }
    return false;
  }

  const handleSubmit =  (event) => {
    const data = {
      userId:userData.id,
      eventId: eventData.currentEvent.id,
      planetCategory: planetCategory.toString(),
      planetOrder:planetOrder.toString(),
    };
    axiosPutWithHeader("/chart/event/planetcategory", data,
      (response)=>{
        setMsgtitle("Event Analyser");
        setMsgbutton("Close");
        if(response.data.code==='200') {
          handleEventData(userData.id,eventData.currentEvent.id);
          setMsgbody("Planet values updated successfully.");
        } else {
          setMsgbody("Error occurred while saving planet values.");
        }
        setErrorMessage("Error");
      },
      (error)=>{
        setMsgtitle("Error");
        setMsgbody("Error occurred while saving");
        setMsgbutton("Close");
        setErrorMessage(error.message);
      }
    );      
    event.preventDefault();
  }

  function handleReset() {
    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetCategory!==null
      &eventData.userEvent.planetCategory!==undefined
    ) {
      setPlanetCategory(eventData.userEvent.planetCategory.split(","));
    } else {
      setPlanetCategory([0,0,0,0,0,0,0,0,0]);
    }

    if(eventData!==null && eventData.userEvent!==null && eventData.userEvent.planetOrder!==null
      &eventData.userEvent.planetOrder!==undefined
    ) {
      setPlanetOrder(eventData.userEvent.planetOrder.split(","));
    } else {
      setPlanetOrder([0,0,0,0,0,0,0,0,0]);
    }

  }

  return(<>
    {spinner===null?<></>:<>{spinner} <Spinner animation="border" size="sm" /></>}
    { eventData===null || eventData===undefined || eventData.length===0 || userData===null || userData===undefined
          || clientData===null || clientData===undefined ?<></>:
      <Collapse in={menuArray[0]} className="m-0 p-0">
        <Row id="eventAnalyserChart" className="m-0 p-0">
          <Col xs={12} className="p-0 m-0 pt-1">
            <Row id="significators" className="m-0 p-0">
              <Col xs={0} lg={3} className="m-0 p-0">
                <table class="table table-hover align-middle caption-top m-0 p-0 text-center TableFont11">
                  <caption class="m-0 p-0 ps-2 pt-2"><h5 class="m-0 p-0">Event Analyser</h5></caption>
                </table>
              </Col>
              <Col xs={12} lg={6} className="p-0 m-0 text-center">
                <Row id="heading" className="m-0 p-0">
                  <Col xs={0} lg={3} className="p-0 m-0 text-start">
                    <DropdownButton id="dropdown-basic-button" title={eventData.currentEvent.name} variant="light" class="m-0 p-0 me-2">
                      <div style={{ maxHeight: '250px', overflowY: 'auto' }}>
                      {Object.keys(eventData.allEvents).map((key, index) => {
                        const event = eventData.allEvents[key];
                        return Object.keys(event).map((key) => {
                          const value = event[key];
                          if(key<0) {
                            return <Dropdown.Divider/>
                          }
                          return <Dropdown.Item onClick={()=>handleEvents(key)} >{value}</Dropdown.Item>
                        })  
                      })}
                      </div>
                    </DropdownButton>
                  </Col>
                  <Col xs={0} lg={9} className="p-0 pt-0 m-0">
                  <div class="input-group m-0 p-0">
                    <input type="input" maxlength="10" class="form-control" title="Primary" value={eventData.currentEvent.primary===null?"":eventData.currentEvent.primary}/>
                    <input type="input" maxlength="10" class="form-control" title="Secondary" value={eventData.currentEvent.secondary===null?"":eventData.currentEvent.secondary}/>
                    <input type="input" maxlength="10" class="form-control" title="Supportive" value={eventData.currentEvent.supportive===null?"":eventData.currentEvent.supportive} />
                    <input type="input" maxlength="10" class="form-control" title="Bad" value={eventData.currentEvent.bad===null?"":eventData.currentEvent.bad}/>
                    <input type="input" maxlength="10" class="form-control" title="worse" value={eventData.currentEvent.worse===null?"":eventData.currentEvent.worse} />
                    <input type="input" maxlength="10" class="form-control" title="Worst" value={eventData.currentEvent.worst===null?"":eventData.currentEvent.worst} />
                  </div>
                  </Col>    
                </Row>
              </Col>
              <Col xs={0} lg={3} className="m-0 p-0"></Col>
            </Row>

            <form method="post" onSubmit={handleSubmit}>
            <Row id="significators" className="m-0 p-0">
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
              <Col xs={12} lg={6} className="m-0 p-0 pt-3">
                <table class="table table-bordered table-hover align-middle caption-top p-0 m-0 text-center TableFont">
                  <thead>
                    <tr class="m-0 p-0" >
                      <th class="m-0 p-1 align-middle">Planet</th> 
                      <th class="m-0 p-1 align-middle">CL</th> 
                      <th class="m-0 p-1 align-middle">OCC</th> 
                      <th class="m-0 p-1 align-middle">CST</th> 
                      <th class="m-0 p-1 align-middle" >CSL</th> 
                      <th class="m-0 p-1 align-middle" >Result</th> 
                      <th class="m-0 p-1 align-middle" >Order</th> 
                    </tr>
                  </thead>
                  <tbody>
                  { eventData.eventSignificators.map((planet,planetIndex) => (
                    <tr class="p-0" >
                      <th class="text-start m-0 p-1 ps-2">{planet[1]}</th>
                      <td class="bg-transparent text-start m-0 p-1 ps-2 kptable-td text-nowrap">{getTag(planet[2])}</td>
                      <td class="bg-transparent text-start m-0 p-1 ps-2 kptable-td text-nowrap">{getTag(planet[3])}</td>
                      <td class="bg-transparent text-start m-0 p-1 ps-2 kptable-td text-nowrap">{getTag(planet[4])}</td>
                      <td class="bg-transparent text-start m-0 p-1 ps-2 kptable-td text-nowrap">{getTag(planet[5])}</td>
                      <td class="bg-transparent text-center m-0 p-1 ps-2 kptable-td">
                        <Form.Select class="bg-transparent m-0 p-1 border-0" name={"category"+planetIndex} value={planetCategory[planetIndex]} style={{backgroundColor:eventData.allPlanetCategory[planetCategory[planetIndex]][2], color:eventData.allPlanetCategory[planetCategory[planetIndex]][3] }} onChange={(event)=>handleColorInput(event,planetIndex)} >
                        {eventData.allPlanetCategory.map((category,index) => (
                          <option key={index} value={index} class="text-start m-0 p-0" style={{backgroundColor:category[2], color:category[3] }} >{isMobile?category[1]:category[0]}</option>
                        ))}
                        </Form.Select>
                      </td>
                      <td class="bg-transparent text-center m-0 p-1 ps-2 kptable-td">
                        <Form.Select class="bg-transparent m-0 p-1 border-0" name={"order"+planetIndex} value={planetOrder[planetIndex]} onChange={(event)=>handleOrderInput(event,planetIndex)} >
                        {loop.map((order,index) => (
                          <option key={index} value={index} class="text-start m-0 p-0" >{order}</option>
                        ))}
                        </Form.Select>
                      </td>
                    </tr>
                  ))}
                  </tbody>
                </table>

              </Col>
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
            </Row>

            <Row id="significators" className="m-0 p-0 pt-3">
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
              <Col xs={12} lg={6} className="m-0 p-0 text-center">
                <SubmitResetButton1 callback={handleReset} /> 
              </Col>
              <Col xs={12} lg={3} className="m-0 p-0"></Col>
            </Row>
            </form>
          </Col>
        </Row>
      </Collapse>
    }
    <ShowGenericAlertError errorAlert={errorMessage} setErrorAlert={setErrorMessage} msgtitle={msgtitle}
        msgbody={msgbody} msgbutton={msgbutton} callback={handleAlertCallback}/>
  </>
  );
}